import type { FC } from "react"

import { ConfirmationDialog } from "@/components/common/Modals"

interface PalletsMismatchConfirmationDialogProps {
  onClose: () => void
  onConfirm: () => void
}

export const PalletsMismatchConfirmationDialog: FC<PalletsMismatchConfirmationDialogProps> = ({
  onClose,
  onConfirm,
}) => (
  <ConfirmationDialog
    title='Pallets Mismatch'
    content='Pallets received and estimated are not the same. Do you want to still finalize check-in?'
    closeLabel='Cancel'
    confirmLabel='Continue Anyway'
    onClose={onClose}
    onConfirm={onConfirm}
  />
)
